export default __webpack_public_path__ + "dc09da5b9405a5ea09ae820549fcf097.svg";